<template>
  <div class="contact">
    <div class="contentInfo">
      <div class="contact">
        <div class="form">
          <div class="title">联系我们</div>
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm">

            <el-form-item label="姓" prop="firstname">
              <el-input v-model="ruleForm.firstname" @keyup.native="keyup" />
            </el-form-item>
            <el-form-item label="名" prop="lastname">
              <el-input v-model="ruleForm.lastname" @keyup.native="keyup" />
            </el-form-item>
            <el-form-item label="电子邮箱" prop="mail">
              <el-input v-model="ruleForm.mail" @keyup.native="keyup" />
            </el-form-item>
            <el-form-item label="电话号码" prop="mobile">
              <el-input v-model="ruleForm.mobile" @keyup.native="keyup" />
            </el-form-item>
            <el-form-item label="公司名称" prop="companyName">
              <el-input v-model="ruleForm.companyName" @keyup.native="keyup" />
            </el-form-item>
            <el-form-item label="职位">
              <el-input v-model="ruleForm.position" @keyup.native="keyup" />
            </el-form-item>
            <el-form-item class="text" label="研究类型">
              <div class="type">(请选择所有你感兴趣的研究）</div>
              <el-checkbox-group v-model="checkList" @change="change">
                <div>
                  <el-checkbox label="医疗保健"></el-checkbox>
                  <el-checkbox label="医疗器械"></el-checkbox>
                  <el-checkbox label="消费者"></el-checkbox>
                </div>
                <div>
                  <el-checkbox label="定量"></el-checkbox>
                  <el-checkbox label="定性"></el-checkbox>
                </div>
                <div>
                  <el-checkbox label="在线调查"></el-checkbox>
                  <el-checkbox label="建模与分析"></el-checkbox>
                  <el-checkbox label="编程与数据处理"></el-checkbox>
                  <el-checkbox label="受访者招募"></el-checkbox>
                  <el-checkbox label="定制社区"></el-checkbox>
                  <el-checkbox label="产品定位测试"></el-checkbox>
                  <el-checkbox label="产品出海"></el-checkbox>
                </div>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item class="text" label="留言" prop="message">
              <el-input type="textarea" v-model="ruleForm.message" @keyup.native="keyup" />
            </el-form-item>

            <el-form-item prop="check" style="width:100%">
              <input class="check" type="checkbox" v-model="ruleForm.check"><span style="word-break: break-word;" class="checkyes">是的，我想接收浩顿品牌的数字通信。我可以在任何时候使用任何电子邮件通信底部的退订链接选择退出通信。</span>
            </el-form-item>
          </el-form>

          <div class="flexCenter">
            <div class="button" @click="submitForm('ruleForm')">
              提 交
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="" :visible="dialogVisible" width="30%">
      <span>感谢您对浩顿的关注！您已成功提交您的信息，我们的团队会尽快与您联系。</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false;$router.push('/cn/index')">OK</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const defaultForm = {
  mail: "",
  firstname: "",
  lastname: "",
  mobile: "",
  position: "", //所属职位
  companyName: "", //公司名称
  interested: "",
  check: true,
  message: "" //留言
};
import { editConsultMail, advertisementFlow } from "@/api/api";
export default {
  name: "Contact",
  data() {
    const check = (rule, value, callback) => {
      if (value == false) {
        return callback(new Error("请填写此必填项"));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: false,
      checkList: [],
      interested: "",
      ruleForm: JSON.parse(JSON.stringify(defaultForm)),
      showTip: false,
      tipStatus: true,
      rules: {
        firstname: [{ required: true, message: "请填写此必填项", trigger: "blur" }],
        lastname: [{ required: true, message: "请填写此必填项", trigger: "blur" }],
        companyName: [{ required: true, message: "请填写此必填项", trigger: "blur" }],
        message: [{ required: true, message: "请填写此必填项", trigger: "blur" }],
        mail: [
          { required: true, message: "请填写此必填项", trigger: "blur" },
          { type: "email", message: "电子邮件格式必须正确", trigger: ["blur"] }
        ],
        check: [{ required: true, message: "请填写此必填项", trigger: "blur" }, { validator: check }]
      }
    };
  },
  created() {
    this.advertisementFlow(); // 在组件创建时加载Google代码
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-11335422054";
    document.head.appendChild(script);
    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "AW-11335422054");
    };
    this.webinercookies();
  },
  methods: {
    webinercookies() {
      // 如果没有记录cookie
      if (!localStorage.getItem("webinersource")) {
        // 就不重新赋值
        let webinersource = this.$route.query.source;

        if (webinersource == undefined) {
          localStorage.setItem("webinersource", "www");
        } else {
          localStorage.setItem("webinersource", webinersource);
        }
        // console.log(1);
      } else {
        // 如果没有cookie就设置cookie
      }
    },
    advertisementFlow() {
      // 如果没有source
      if (this.$route.query.source == undefined) {
        // console.log(1);
        // 就把source拼接
        advertisementFlow({
          path: "contact",
          source: "",
          information: "联系我们"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
        // 如果有source
      } else {
        advertisementFlow({
          path: "contact",
          source: this.$route.query.source,
          information: "联系我们"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
      }
    },
    change() {
      this.interested = this.checkList.join();
      // console.log(this.interested);
    },
    keyup() {
      this.$refs["ruleForm"].clearValidate();
    },
    submitForm(formName) {
      let _this = this;
      _this.$refs[formName].validate(valid => {
        if (valid) {
          _this.ruleForm.fullName = _this.ruleForm.firstname + " " + _this.ruleForm.lastname;
          let ruleForm = {
            fullName: _this.ruleForm.fullName,
            mail: _this.ruleForm.mail,
            mobile: _this.ruleForm.mobile,
            position: _this.ruleForm.position,
            companyName: _this.ruleForm.companyName,
            message: _this.ruleForm.message,
            interested: _this.interested
          };
          this.checkList = [];
          editConsultMail(ruleForm).then(res => {
            console.log(res);
            if (res.code == 10000) {
              _this.showTip = true;
              _this.tipStatus = true;
              _this.ruleForm = JSON.parse(JSON.stringify(defaultForm));
              this.dialogVisible = true;
            } else {
              _this.showTip = true;
              _this.tipStatus = false;
            }
          });
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.check {
  margin-right: 10px;
}
.marginTop30 {
  margin-top: 0.3rem;
}
.fontBold {
  font-weight: bold;
}
.contentInfo {
  background: url("~@/assets/img/contact.jpg") no-repeat center top;
  background-size: 100% 100%;
  width: 100%;
  padding: 100px 0 75px;
  .contact {
    padding: 50px 63px;
    width: 888px;
    margin: 0 auto;
    background: #fff;
    .form {
      .title {
        font-size: 40px;
        text-align: center;
        margin-bottom: 20px;
        font-weight: 700;
      }
      .el-form {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        /deep/ .el-form-item {
          display: inline-block;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          &:nth-child(even) {
            .el-form-item__label {
              margin-left: 7px;
            }
          }
          &:not(.text) {
            width: 50%;
          }
          &.text {
            width: 100%;
          }
          .el-form-item__content {
            flex: 1;
            .el-input {
              width: 238px !important;
            }
          }

          .el-form-item__label {
            width: 133px;
            font-size: 15px;
            display: block;
            font-weight: normal;
          }
          .el-textarea__inner {
            min-height: 104px !important;
          }
          .el-input__inner,
          .el-textarea__inner {
            // width: 250px;
            background: #fafafa;
            border: 1px solid #e6e6e6;
            border-radius: 7px;
            font-size: 15px;
          }
          .el-textarea__inner {
            width: 500px;
          }
          .el-form-item__error {
            font-size: 12px !important;
          }
        }
      }
      .button {
        margin-top: 17px;
        background: #217df6;
        font-size: 13px;
        color: #fff;
        border-radius: 7px;
        text-align: center;
        width: 91px;
        height: 34px;
        line-height: 34px;
        cursor: pointer;
      }
    }
  }
}
@media screen and (max-width: 576px) {
  .checkyes {
    font-size: 60px;
  }
  .type {
    font-size: 70px;
  }
  .check {
    width: 100px;
    height: 100px;
  }
  .contentInfo {
    .contact {
      width: 90%;
      .form {
        .el-form {
          /deep/ .el-form-item {
            &:not(.text) {
              width: 100%;
            }
            .el-form-item__content {
              flex: 1;
              .el-input {
                width: 100% !important;
                margin-bottom: 30px;
              }
            }
            .el-form-item__label {
              // width: 400px;
              width: 100%;
              text-align: left;
              line-height: 100px;
              font-size: 70px !important;
            }
            .el-form-item__label::before {
              // position: static;
            }
            .el-input__inner {
              width: 1000px;
              height: 100px;
              font-size: 60px !important;
            }
            .el-textarea__inner {
              width: 1000px;
              height: 300px;
              font-size: 60px !important;
            }
            .el-form-item__error {
              top: 100px;
              font-size: 40px !important;
            }
            .type {
              line-height: 70px;
            }
            .el-checkbox-group {
              font-size: 40px;
              .el-checkbox {
                margin: 10px;
              }
              .el-checkbox__input {
                .el-checkbox__inner {
                  width: 80px;
                  height: 80px;
                }
                .el-checkbox__label {
                  font-size: 70px !important;
                }
              }
            }
          }
        }
        .button {
          width: 350px;
          height: 100px;
          font-size: 70px;

          padding: 30px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
@media screen and (max-width: 576px) {
  .el-dialog {
    padding: 100px;
    width: 90% !important;
    // height: 1000px;
    font-size: 100px;
    .el-dialog__body {
      text-align: center;
      padding: 100px;
      font-size: 50px;
      word-break: break-word;
    }
    .el-button--default,
    .el-button--primary {
      padding: 50px 70px;
      font-size: 50px;
    }
  }
  .el-checkbox {
    font-size: 70px !important;
    .el-checkbox__label {
      font-size: 70px;
    }
  }
}
</style>
